import { useRouter } from 'next/router';

export const useIsOrderConfirmationPage = () => {
  const router = useRouter();

  return router.route === '/[locationSlug]/[merchantSlug]/[merchantId]/thank-you/[orderId]';
};
